import { render, staticRenderFns } from "./InsCatLayout1.vue?vue&type=template&id=58c08b54&scoped=true"
import script from "./InsCatLayout1.vue?vue&type=script&lang=ts"
export * from "./InsCatLayout1.vue?vue&type=script&lang=ts"
import style0 from "./InsCatLayout1.vue?vue&type=style&index=0&id=58c08b54&prod&lang=less"
import style1 from "./InsCatLayout1.vue?vue&type=style&index=1&id=58c08b54&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c08b54",
  null
  
)

export default component.exports